import {Button, Grid, TextField} from '@mui/material';
import {useState} from 'react';

export interface TextFieldWithButtonProps {
  onClickButton: (inputValue: string) => void;
  label?: string;
  helperText?: string;
}

export default function TextFieldWithButton({onClickButton, label, helperText}: TextFieldWithButtonProps) {
  const [inputValue, setInputValue] = useState('');

  const handleButtonClick = () => {
    onClickButton(inputValue);
  };

  return (
    <Grid container alignItems="center" spacing={2}>
      <Grid>
        <TextField
          label={label}
          helperText={helperText}
          value={inputValue}
          onChange={(e) => setInputValue(e.target.value)}
          variant="outlined"
          fullWidth
        />
      </Grid>
      <Grid>
        <Button variant="contained" color="primary" onClick={handleButtonClick}>
          Submit
        </Button>
      </Grid>
    </Grid>
  );
}
